import React from "react";
import { CircularProgress, Container, Stack } from "@mui/material";
import { HSpacer, IconButton, Text, VSpacer } from "@/components/DesignSystem";
import { RedemptionSku }
  from "@/pages/Admin/HierarchyOfRetailers/Wallet/CreateOrEditSubwalletDialog";
import Delete from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import { useQuery } from "react-query";
import { QueryKeys } from "@/constants/QueryKeys";
import { SubwalletApi } from "@/utilities/api/SubwalletApi";

interface RedemptionSkuListItemProps {
  onDelete: () => void,
  onEdit: (hasPointsHistory: boolean) => void,
  redemptionSku: RedemptionSku,
  subwalletId?: string,
}

export const RedemptionSkuListItem = ({
  onDelete,
  onEdit,
  redemptionSku,
  subwalletId,
} : RedemptionSkuListItemProps) => {
  const { data: hasPointsHistory, isFetching } = useQuery(
    [QueryKeys.HAS_POINTS_HISTORY, subwalletId, redemptionSku],
    () => SubwalletApi.hasPointsHistory(subwalletId!, {
      redemptionSkuExternalId: redemptionSku.externalId,
    }),
    { enabled: !!subwalletId },
  );

  return (
    <Stack
      alignItems="center"
      direction="row"
      justifyContent="space-between"
      key={redemptionSku.externalId}
    >
      <Stack alignItems="center" direction="row" justifyContent="space-between">
        <Text breakWord category="body-medium" width="207px">
          {redemptionSku.name}
        </Text>
        <HSpacer size="4" />
        <Text breakWord category="body-medium" width="207px">
          {redemptionSku.externalId}
        </Text>
      </Stack>
      {!!isFetching && (
        <Container>
          <Stack alignItems="center">
            <VSpacer size="14" />
            <CircularProgress />
          </Stack>
        </Container>
      )}
      {!isFetching && (
        <>
          <IconButton
            disabled={hasPointsHistory}
            onClick={onDelete}
            sx={{ visibility: hasPointsHistory ? 'hidden' : 'visible' }}
            testID="delete-redemption-sku-button"
          >
              <Delete sx={{ width: '20px' }} />
            </IconButton>
          <IconButton
            onClick={() => onEdit(hasPointsHistory!)}
            testID="delete-redemption-sku-button"
          >
            <Edit sx={{ width: '20px' }} />
          </IconButton>
        </>
      )}
    </Stack>
  );
};